import { AppRegistry, Platform } from 'react-native';

// Register background message handler BEFORE App import (required by React Native Firebase)
// Wrapped in try/catch: a messaging/Firebase config problem must not prevent
// the App import + AppRegistry.registerComponent('main', ...) below from
// running, or the whole app fails with "main has not been registered".
if (Platform.OS !== 'web') {
  try {
    const messaging = require('@react-native-firebase/messaging').default;
    messaging().setBackgroundMessageHandler(async (remoteMessage) => {
      console.log('[Background] FCM Message received:', remoteMessage);
      // Background messages are automatically displayed by Android/iOS system
      // The notification tap handling is done by onNotificationOpenedApp in App.tsx
    });
  } catch (error) {
    console.error('Failed to set up FCM background message handler:', error);
  }
}

let App;
try {
  // Wrap the import in a try-catch to see what's failing
  App = require('./App').default;
  console.log('App imported successfully');
} catch (error) {
  console.error('ERROR importing App:', error);
  console.error('Error stack:', error.stack);
  // Fallback to a simple error screen
  const React = require('react');
  const { View, Text } = require('react-native');
  App = () => React.createElement(View, { style: { flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: 'red' } },
    React.createElement(Text, { style: { color: 'white', padding: 20 } }, 'Error loading app: ' + (error.message || String(error))));
}

// Register the main component
try {
  AppRegistry.registerComponent('main', () => App);
  console.log('App registered successfully');
} catch (error) {
  console.error('ERROR registering App:', error);
}

// For web, we need to run the app on the DOM
if (Platform.OS === 'web') {
  const rootTag = document.getElementById('root');
  if (rootTag) {
    AppRegistry.runApplication('main', { rootTag });
  }
}

export default App;